"use client";
import { createContext, useState, useEffect } from "react";
import { useRouter } from "next/navigation";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authTokens, setAuthTokens] = useState(() => {
    if (typeof window !== "undefined") {
      return JSON.parse(localStorage.getItem("authTokens")) || null;
    }
    return null;
  });
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    if (authTokens) {
      obtenerUsuario();
    } else {
      setLoading(false);
    }
  }, [authTokens]);

  const refreshToken = async () => {
    const refresh = authTokens?.refresh;
    if (!refresh) {
      logout();
      return null;
    }

    try {
      const response = await fetch("http://192.168.100.27:8000/api/token/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refresh }),
      });

      if (response.ok) {
        const data = await response.json();
        const newTokens = { ...authTokens, access: data.access };
        localStorage.setItem("authTokens", JSON.stringify(newTokens));
        setAuthTokens(newTokens);
        return data.access;
      } else {
        console.error("Error refrescando token, cerrando sesión...");
        logout();
        return null;
      }
    } catch (error) {
      console.error("Error en la solicitud de refresco de token:", error);
      logout();
      return null;
    }
  };

  const obtenerUsuario = async () => {
    let token = authTokens?.access;
    if (!token) {
      token = await refreshToken();
      if (!token) return;
    }

    try {
      const res = await fetch("http://192.168.100.27:8000/api/auth/user/", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.ok) {
        const data = await res.json();
        setUser(data);
      } else {
        console.error("Token inválido. Cerrando sesión...");
        logout();
      }
    } catch (error) {
      console.error("Error obteniendo usuario:", error);
      logout();
    }
    setLoading(false);
  };

  const login = async (username, password) => {
    setLoading(true);
    const response = await fetch("http://192.168.100.27:8000/api/auth/login/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    if (response.ok) {
      const data = await response.json();
      setAuthTokens(data);
      setUser(data.user);
      localStorage.setItem("authTokens", JSON.stringify(data));
      router.push("/");
    } else {
      alert("Usuario o contraseña incorrectos");
    }
    setLoading(false);
  };

  const logout = () => {
    localStorage.removeItem("authTokens");
    setAuthTokens(null);
    setUser(null);
    router.push("/login");
  };

  return (
    <AuthContext.Provider value={{ user, authTokens, login, logout, loading, refreshToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
